import {Component, Inject} from '@angular/core';
import {kanUsersService} from "../../../services/services/users";
import {User} from "../../../../classes/user";
import {DateAdapter, MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {getDateString} from "../../../../utils/dateFormat";
import {Observable} from "rxjs/Observable";
import {kanPartnersService} from "../../../services/services/partners";
import {Partner} from "../../../../classes/partner";

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

@Component({
    selector: 'kan-user-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanUserDialog {

    public generalDataForm: FormGroup;
    public adressForm: FormGroup;
    public membershipForm: FormGroup;

    public searchText: string = '';
    public users: User[];
    public filteredUsers: User[];
    public partners: Partner[];
    public filteredPartners: Partner[];
    public selectedGodfather: any;
    public godfatherControl: FormControl = new FormControl();
    public birthday: string;
    public user: User = new User();
    public isNew: boolean = true;
    public oldEmail: string;
    public genders: string[] = ['MALE', 'FEMALE'];
    public godfatherTypes: string[] = ['web', 'user', 'partner', 'other'];
    public godfatherType: string = 'web';
    public firstContactTypes: string[] = ['PHONE_CALL', 'SOCIAL_MEDIA', 'EMAIL', 'WHATSAPP', 'VISIT', 'WEB'];

    constructor(private dialogRef: MatDialogRef<kanUserDialog>,
                private adapter: DateAdapter<any>,
                private formBuilder: FormBuilder,
                private userService: kanUsersService,
                private partnersService: kanPartnersService,
                @Inject(MAT_DIALOG_DATA) private data: any) {
        if (this.data && this.data.user) {
            this.user = JSON.parse(JSON.stringify(this.data.user));
            this.birthday = this.user.birthday ? getDateString(new Date(this.user.birthday)) : '';
            this.oldEmail = this.user.email;
            this.isNew = false;
            this.godfatherType = this.user.gfType;
        }
    }

    ngOnInit(): void {

        this.userService.getUsers({
            where: {
                role: 'USER',
                active: true
            }
        })
            .then((users: User[]) => {
                this.users = users;
                this.filterUsers(null);
                if (this.user.godfatherType === 'user') {
                    this.selectedGodfather = this.users.find((user) => {
                        return user.id === this.user.godfatherId;
                    });
                    this.searchText = (this.selectedGodfather.surname ? this.selectedGodfather.surname + ', ' : '') + this.selectedGodfather.name;
                }
            })
            .catch((error: any) => {
                console.log(error);
            });

        this.partnersService.getPartners()
            .then((partners: Partner[]) => {
                this.partners = partners;
                this.filterPartners(null)
                if (this.user.godfatherType === 'partner') {
                    this.selectedGodfather = this.partners.find((partner) => {
                        return partner.id === this.user.godfatherId;
                    });
                    this.searchText = this.selectedGodfather.name;
                }
            })
            .catch((error: any) => {
                console.log(error);
            });

        this.adapter.setLocale('es');

        this.generalDataForm = this.formBuilder.group({
            gfType: new FormControl(this.user.gfType, [Validators.required]),
            godfather: new FormControl(this.selectedGodfather),
            name: new FormControl(this.user.name, [Validators.required]),
            surname: new FormControl(this.user.surname),
            email: new FormControl(this.user.email, [Validators.pattern(EMAIL_REGEX)]),
            phone: new FormControl(this.user.phone),
            dni: new FormControl(this.user.dni),
            birthday: new FormControl(this.birthday),
            gender: new FormControl(this.user.gender),
            firstContact: new FormControl(this.user.firstContact)
        });

        this.adressForm = this.formBuilder.group({
            address: new FormControl(this.user.address),
            city: new FormControl(this.user.city),
            cp: new FormControl(this.user.cp)
        });

        this.membershipForm = this.formBuilder.group({
            emailing: new FormControl(this.user.emailing),
            membershipNumber: new FormControl(this.user.membershipNumber)
        });
    }

    public godfatherTypeChange(event) {
        this.selectedGodfather = null;
        this.searchText = '';
        if (this.godfatherType === 'web' || this.godfatherType === 'other') {
            this.generalDataForm.controls.godfather.setErrors(null);
        }
    }

    public filterUsers(event) {
        if (!this.users) {
            this.filteredUsers = [];
        } else if (typeof this.searchText === 'string' || !this.searchText) {
            this.filteredUsers = this.users.filter((user) => {
                let arr = (this.searchText || '').split(' ');
                let found = true;
                arr.forEach((item) => {
                    if (item) {
                        found = found && (user.name.toLowerCase().includes(item.toLowerCase()) || (user.surname ? user.surname.toLowerCase().includes(item.toLowerCase()) : false));
                    }
                });
                return found;
            }).slice(0, 30);
        }
    }

    public filterPartners(event) {
        if (!this.partners) {
            this.filteredPartners = [];
        } else if (typeof this.searchText === 'string' || !this.searchText) {
            this.filteredPartners = this.partners.filter((partner) => {
                let arr = (this.searchText || '').split(' ');
                let found = true;
                arr.forEach((item) => {
                    if (item) {
                        found = found && (partner.name.toLowerCase().includes(item.toLowerCase()));
                    }
                });
                return found;
            }).slice(0, 30);
        }
    }

    public userSelected(event) {
        this.selectedGodfather = event.option.value;
        this.searchText = (this.selectedGodfather.surname ? this.selectedGodfather.surname + ', ' : '') + this.selectedGodfather.name;
    }

    public partnerSelected(event) {
        this.selectedGodfather = event.option.value;
        this.searchText = this.selectedGodfather.name;
    }

    public onGodfatherBlur(event: any) {
        setTimeout(() => {
            if (this.selectedGodfather) {
                this.searchText = (this.selectedGodfather.surname ? this.selectedGodfather.surname + ', ' : '') + this.selectedGodfather.name
            } else {
                this.searchText = '';
            }
        }, 100);
    }

    public checkEmail(event: any) {
        if (this.generalDataForm.controls.email.valid && this.user.email !== this.oldEmail) {
            this.userService.isEmailUsed(this.user.email)
                .then((isUsed) => {
                    this.generalDataForm.controls.email.setErrors(isUsed ? {'used': true} : null);
                });
        }
    }

    public addUser(event: any) {
        this.user.birthday = this.birthday ? new Date(this.birthday) : null;
        this.user.gfType = this.godfatherType;
        this.user.godfatherType = this.godfatherType !== 'web' && this.godfatherType !== 'other' ? this.godfatherType : null;
        this.user.godfatherId = this.selectedGodfather ? this.selectedGodfather.id : null;
        this.user.agree = true;
        this.user.agreeDate = new Date();

        this.userService.addUser(this.user)
            .then((data) => {
                this.dialogRef.close('add')
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public updateUser(event: any) {
        this.user.birthday = this.birthday ? new Date(this.birthday) : null;
        this.user.gfType = this.godfatherType;
        this.user.godfatherType = this.godfatherType !== 'web' && this.godfatherType !== 'other' ? this.godfatherType : null;
        this.user.godfatherId = this.selectedGodfather ? this.selectedGodfather.id : null;
        this.userService.updateUser(this.user)
            .then((data) => {
                this.dialogRef.close('update')
            })
            .catch((error) => {
                console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/dialogs/user-dialog/component.ts